<template>
  <div class="nf-confirm" :class="{ sougou: isSouGouBrowser }">
    <el-dialog
      v-drag="{
        dragClassName: '.el-dialog',
        selectClassName: '.el-dialog__header',
      }"
      :title="title"
      :visible.sync="show"
      :append-to-body="appendToBody"
      :close-on-click-modal="$store.state.element.closeOnClickModal"
      :close-on-press-escape="$store.state.element.closeOnPressEscape"
      :show-close="false"
      :width="width ? width : $store.state.element.width"
    >
      <slot name="title" />
      <div v-if="showClose" class="close" @click="handleCancelBtnTap">
        <i class="el-icon-close" />
      </div>
      <el-scrollbar v-if="!appendToBody" :style="{ height: scrollbarH, borderTop: borderT }">
        <slot name="content" />
      </el-scrollbar>
      <slot v-else name="content" />
      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="end">
          <slot name="footer" />
          <div v-if="!$slots.footer">
            <el-button v-if="isCancelBtn" @click="handleCancelBtnTap">
              {{ ancelBtnText }}
            </el-button>
            <el-button
              v-if="isSavelBtn"
              :loading="isLoading"
              type="primary"
              @click="handleSaveBtnTap"
            >
              {{ saveBtnText }}
            </el-button>
          </div>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { clearTimeout, setTimeout } from 'timers';
var timer = null;
export default {
  name: 'NfConfirm',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true,
    },
    // 滚动区域高度
    scrollbarH: {
      type: String,
      default: '300px',
    },
    title: {
      type: [String, Number],
      default: '',
    },
    width: {
      type: [String, Boolean],
      default: false,
    },
    // 是否显示取消按钮
    isCancelBtn: {
      type: Boolean,
      default: true,
    },
    // 取消按钮显示的文字
    ancelBtnText: {
      type: [String, Number],
      default: '取 消',
    },
    // 是否显示确认按钮
    isSavelBtn: {
      type: Boolean,
      default: true,
    },
    // 确认按钮显示的文字
    saveBtnText: {
      type: [String, Number],
      default: '确 定',
    },
    // 点击确定事件
    handleSaveBtnClick: {
      type: [Boolean, Function],
      default: false,
    },
    // 点击取消确定事件
    handleCancelBtnClick: {
      type: [Boolean, Function],
      default: false,
    },
    // Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    // 判断是否为搜狗浏览器
    // 搜狗有兼容性问题 弹出框 能漏出来一层灰色点边 用CSS定位来解决
    isSouGouBrowser() {
      return navigator.userAgent.toLowerCase().includes('se 2.x');
    },
  },
  methods: {
    // 确定按钮
    handleSaveBtnTap() {
      const done = (isTrue = true) => {
        if (!isTrue) {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            this.isLoading = isTrue;
          }, 500);
        } else {
          this.isLoading = isTrue;
        }
      };
      if (this.handleSaveBtnClick) {
        if (!this.isLoading) {
          this.handleSaveBtnClick(done);
        }
      }
    },
    // 取消按钮
    handleCancelBtnTap() {
      if (this.handleCancelBtnClick) {
        this.handleCancelBtnClick();
      } else {
        this.$emit('update:show', false);
      }
    },
  },
};
</script>
<style scoped>
.close {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}
.close i {
  font-size: 16px;
  margin: 0 auto;
}
.nf-confirm >>> .el-dialog__body {
  padding-bottom: 0;
  padding-top: 0;
}
.nf-confirm >>> .el-scrollbar__wrap {
  position: relative;
  bottom: -17px;
}
.sougou >>> .el-scrollbar__wrap {
  bottom: -22px;
}
</style>
